import LoadGoogleMapsAPI from "load-google-maps-api"
import SimpleComponentRegistery from "../qlib/SimpleComponentRegistery"
import Component from "../qlib/Component"

export default class GMapComponent extends Component
{
    constructor(element)
    {
        super(element)

        this.locations = []
        this.api = undefined
        this.map = undefined


        this.zoom = this.element.dataset.hasOwnProperty('zoom') ? this.element.dataset.zoom : 10
        this.center = {
            lat: this.element.dataset.hasOwnProperty('lat') ? this.element.dataset.lat : 52.632359,
            lng: this.element.dataset.hasOwnProperty('lng') ? this.element.dataset.lng : 4.750680
        }

        this.isOverview = this.element.dataset.hasOwnProperty('overview')
        this.isReferenties = this.element.dataset.hasOwnProperty('referenties')


        let that = this;
        setTimeout(function(){
            that.load()
        }, 5000);
    }

    async load()
    {
        await this.loadMap()
        await this.requestLocations()

        for (let i in this.locations)
        {
            let location = this.locations[i]
            if (location.lat === 0 && location.lng === 0) continue

            let markerIndex;
            let icon = '/assets/dist/images/vanalkemare-pin.png'
            if (!this.isOverview && (location.lat.toString() === this.center.lat && location.lng.toString() === this.center.lng))
            {
                icon = '/assets/dist/images/vanalkemare-pin-orange.png';
                markerIndex = 99999;
            }
            let marker = new this.api.Marker({
                position: new this.api.LatLng(location.lat, location.lng),
                map: this.map,
                title: location.name,
                icon: icon,
                zIndex: markerIndex
            })
            marker.location = location;

            marker.addListener('click', event => {
                this.markerOnClick(event, marker)
            })
        }

        if (! this.isOverview) this.generateStaticMap();
    }

    generateStaticMap()
    {
        const _distX = (x, y) => (x.lat - y.lat) * (x.lat - y.lat);
        const _distY = (x, y) => (x.lng - y.lng) * (x.lng - y.lng);
        const dist = (x, y) => Math.abs(Math.sqrt(_distY(x, y) + _distX(x, y)))

        const sorted_locations = this.locations.filter(location => {
            return dist(this.center, location) > 0;
        }).sort((a, b) => {
            return dist(this.center, a) - dist(this.center, b);
        }).splice(0, 5);

        const static_parent = this.element.parentElement.querySelector('.js-static-gmap');
        const element = document.createElement('img');
        const chunks = sorted_locations.map(location => `${location.lat},${location.lng}`);
        const zoom = static_parent.dataset.hasOwnProperty('zoom') ? static_parent.dataset.zoom : 10;
        element.src = `https://maps.googleapis.com/maps/api/staticmap?center=${this.center.lat},${this.center.lng}&zoom=${zoom}&size=640x640&key=AIzaSyB3rzOQNIjjAGnRp1axbdhJZwkqKY0AAXs&markers=|icon:https://vanalkemare.nl/assets/dist/images/vanalkemare-pin.png|${chunks.join('|')}&markers=icon:https://vanalkemare.nl/assets/dist/images/vanalkemare-pin-orange.png|${this.center.lat},${this.center.lng}`;
        static_parent.appendChild(element);
    }

    async loadMap()
    {
        this.api = await LoadGoogleMapsAPI({key: 'AIzaSyB3rzOQNIjjAGnRp1axbdhJZwkqKY0AAXs'})

        this.map = new this.api.Map(this.element, {
            center: {
                lat: parseFloat(this.center.lat),
                lng: parseFloat(this.center.lng)
            },
            zoom: parseFloat(this.zoom)
        })
    }

    async requestLocations()
    {
        let json = [];

        if (this.element.dataset.hasOwnProperty('locations')) {
            json = JSON.parse(this.element.dataset.locations);
        }


        if (json.length === 0) {

            let params = '?';
            if (this.isReferenties) {
                params += 'referenties=1';
            }

            let response = await fetch('/api/locaties'+params)
            json = await response.json()
        }

        json.forEach(coord => {
            this.locations.push(coord)
        })
    }

    async markerOnClick(event, marker)
    {
        let windowContent = this.createInfoWindowElement(marker);
        if (!windowContent) {
            return;
        }

        let infoWindow = new this.api.InfoWindow({content: windowContent})
        infoWindow.open(this.map, marker)
    }

    createInfoWindowElement(marker)
    {
        let template_element = document.querySelector('#map-template')

        if (!template_element) {
            return;
        }

        let template_clone = template_element.content.cloneNode(true);

        let addr = template_clone.querySelectorAll('.js-map-template-address');
        addr.forEach(addrEl => {
            addrEl.innerHTML = marker.location.name
        });

        if (marker.location.type) {
            this.createRow(template_clone, 'Type', marker.location.type);
        }

        if (marker.location.status) {
            this.createRow(template_clone, 'Status', marker.location.status);
        }

        if (marker.location.imageUrl) {
            let img = template_clone.querySelector('.js-map-template-img');
            img.src = marker.location.imageUrl;
        }

        if (marker.location.url) {
            let aLink = template_clone.querySelector('.js-map-template-url');
            aLink.href = marker.location.url;
        }

        let dataid = template_clone.querySelector('.js-map-template-data-id');
        if (marker.location.pandId && dataid) {
            dataid.dataset.pandid = marker.location.pandId;
            dataid.dataset.pandurl = marker.location.url;
            dataid.dataset.alertNoReplaceForm = 1;
        }

        let prices = marker.location.prices;
        if (prices) {
            for (var key in prices) {
                if (!prices.hasOwnProperty(key)) continue;
                this.createRow(template_clone, key, prices[key]);
            }
        }

        return template_clone;
    }

    createRow(templateClone, label, value)
    {
        let table = templateClone.querySelector('.js-map-template-table');
        let row = templateClone.querySelector('.js-map-template-row').cloneNode(true);
        let columns = row.querySelectorAll('.js-map-template-column');
        columns[0].innerHTML = label;
        columns[1].innerHTML = value;
        row.style.display = '';
        table.appendChild(row);
    }



    isHTTPS()
    {
        return window.location.href.indexOf('https://') == 0
    }
}

SimpleComponentRegistery.register("gmap", GMapComponent);